export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Llegaba al km 25 y mi cabeza me decía que parara. Con el Tomo 3 aprendí a identificar el autosabotaje y terminé mi primer 42K sin caminar. Increíble.',
    name: 'Marcos R.',
    location: 'Buenos Aires · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7a285255-6047-46c5-9f19-5dd5198a84c0.jpg',
  },
  {
    quote:
      'Los nervios antes de las carreras me arruinaban el rendimiento. El tomo de Ansiedad Bajo Control cambió todo. Ahora llego al inicio tranquila y enfocada.',
    name: 'Carolina L.',
    location: 'Santiago · Chile',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c4912877-2552-46bd-bc1e-c948f180c336.jpg',
  },
  {
    quote:
      'Nunca pensé que el problema era mental. Entrenaba más que nadie y no mejoraba. El tomo de Flow y las Micro-Metas me bajaron 4 minutos en el 10K.',
    name: 'Julián P.',
    location: 'Medellín · Colombia',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ed649827-3bd1-4800-b3e3-bd9d2f224c24.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Empecé a leerlo un martes y para el domingo de carrera ya tenía una rutina pre-competencia completamente diferente. Sin el pack hubiera llegado al inicio destrozado mentalmente como siempre. Vale cada peso.',
    name: 'Santiago R.',
    location: 'Córdoba · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/6384f0cf-90db-4c28-b54d-f9f130ce8625.jpg',
  },
  {
    quote:
      'El tomo de Autosabotaje me abrió los ojos. Me estaba boicoteando yo misma sin saberlo. Ahora tengo herramientas para frenar esa voz antes de que me destruya la carrera.',
    name: 'Andrea C.',
    location: 'Bogotá · Colombia',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/076e4df0-fb0e-4b7d-86ea-40eedfbcd488.jpg',
  },
  {
    quote:
      'Venía de tres abandonos seguidos. El bono de Recuperación Cognitiva fue lo primero que leí y en ese momento entendí que mi cerebro estaba agotado, no mis piernas. Cambió todo.',
    name: 'Diego F.',
    location: 'Asunción · Paraguay',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7bb77e3a-c5b3-4ddc-9a9c-90e780dcf207.jpg',
  },
  {
    quote:
      'No sabía si seguir entrenando o dejarlo. El tomo de Identidad Imparable me dio la claridad que meses de duda no me habían dado. Tomé la decisión más importante de mi carrera deportiva con la cabeza fría.',
    name: 'Valeria B.',
    location: 'Lima · Perú',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ba16684a-8b21-4ed6-8a96-844b46cf6770.jpg',
  },
];
